export default __webpack_public_path__ + "static/media/spotify.4f8bc335.svg";